import { Flex, Text } from "@/atoms"
import { Code } from "@/molecules/Code"
import { CLIENT_ID_PLACEHOLDER } from "./AppRegistrationSteps.constants"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

import type { ManagementAppProps } from "./AppRegistrationSteps.types"

// Either command registers the app, with the client id once it is entered
export const ManagementApp = ({ clientId }: ManagementAppProps) => {
  const t = useAppRegistrationTranslation()
  const id = clientId.trim() || CLIENT_ID_PLACEHOLDER
  const powerShell = `New-PowerAppManagementApp -ApplicationId ${id}`
  const pac = `pac admin application register --application-id ${id}`

  return (
    <Flex vertical gap={8}>
      <Text>{t("managementApp")}</Text>
      <Code.CommandCard>
        <Code.CommandSnippet
          comment={t("powerShell")}
          instruction=""
          commands={powerShell}
          copyText={powerShell}
        />
        <Code.CommandSnippet
          comment={t("pac")}
          instruction=""
          commands={pac}
          copyText={pac}
        />
      </Code.CommandCard>
    </Flex>
  )
}
